module.exports = __webpack_public_path__ + "static/media/instructor-successful-teams1.43f45619.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-successful-teams1.png
// module id = 2590
// module chunks = 0